import { api, parseApiError } from './api';
import type { Tag, TagsListResponse, CreateTagInput } from '@/types/tag';

export const tagsService = {
  /**
   * Get all tags for the authenticated user
   */
  async getTags(): Promise<TagsListResponse> {
    try {
      const response = await api.get<TagsListResponse>('/api/tags');
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Create a new tag
   */
  async createTag(data: CreateTagInput): Promise<Tag> {
    try {
      const response = await api.post<Tag>('/api/tags', data);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Delete a tag
   */
  async deleteTag(id: string): Promise<void> {
    try {
      await api.delete(`/api/tags/${id}`);
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default tagsService;
